import * as React from 'react';
import type { ReactNode } from 'react';

import type { Recommender } from '@coursera/event-pulse-types';

import PageConfigComponentMetadataContext from 'bundles/page-config-common/contexts/PageConfigComponentMetadataContext';

type Props = {
  children: ReactNode;
  id: string;
  index: number;
  name?: string;
  recommender?: Recommender;
};

const PageConfigComponentMetadataProvider = ({ children, id, index, name, recommender }: Props) => {
  return (
    <PageConfigComponentMetadataContext.Provider value={{ id, index, name, recommender }}>
      {children}
    </PageConfigComponentMetadataContext.Provider>
  );
};

export default PageConfigComponentMetadataProvider;
